import React            from 'react';
import box_0            from 'images/box_0.png';
import box_1            from 'images/box_1.png';
import box_2            from 'images/box_2.png';
import box_3            from 'images/box_3.png';
import box_4            from 'images/box_4.png';
import box_5            from 'images/box_5.png';
import box_6            from 'images/box_6.png';
import box_7            from 'images/box_7.png';
import box_8            from 'images/box_8.png';
import box_9            from 'images/box_9.png';
import { getPage }      from '../pages';
import sizes            from 'utils/sizes';
import closedBox        from 'images/closedBox.png';

import { makeStyles } from "makeStyles";
import { objType } from 'types';

//var clsx = require('classnames')

const arr = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9, closedBox];

const useStyles = makeStyles()(
    (theme) => ({
    root: {
        width:              '100%',
        height:             '100%',
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        display:            'flex',
        alignItems:         'center',
        flexFlow:           'column',
        touchAction:        'manipulation',
        transition:         'transform 2s'
    },
    tenBox: {
      position:           'absolute',
      width:              '100%',
      height:             '100%',
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat',
      transition:         'transform 2s'
    },
    text: {
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      color:           theme.blue,
      fontSize:        30,
      backgroundColor: '#FFF',
      borderRadius:    '50%',
      height:          40,
      width:           40
    }
  })
);

type EggBoxProps = {
    value:         number;
    pageNum:       number;
    tensVal:       number;
    droppablePos0: objType;
    droppablePos1: objType;
    wideScreen:    boolean;
}

const EggBox: React.FC<EggBoxProps> = ({ 
  value,
  pageNum,
  tensVal,
  droppablePos0,
  droppablePos1,
  wideScreen, 
}) => {

  const { classes } = useStyles();

  const [myPos, setMyPos] = React.useState({ x: -1, y: -1 })
  

  const boxRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (boxRef && boxRef.current) {
       if (myPos.y === -1) {
 
           const { x, y } = boxRef.current.getBoundingClientRect();
           
           setMyPos({ x: x, y: y })
 
          }

       }
       
   },[myPos, boxRef])


  


  const [rootStyle, draggableStyle, draggableStyle0, draggableStyle2, draggableStyle3, draggableStyle4] = React.useMemo(() => {


      const { bigBoxWidth, bigBoxHeight, smallBoxHeight } = sizes;
      const width = wideScreen ? bigBoxWidth : '19vw'

      const style = {
        backgroundImage: `url(${ arr[value] })`,
        width:           width,
        height:          wideScreen ? bigBoxHeight : smallBoxHeight,
      }

      const transform0 = pageNum === getPage('dragTen0');
      const transform1 = ((value === 10 && pageNum >= getPage('dragTen1')) || (value === 7 && pageNum >= getPage('dragUnits1')));
      const transform2 = pageNum >= getPage('dragTen2');
      const transform3 = pageNum >= getPage('dragTen3');
      const transform4 = pageNum === getPage('dragTen4');
      const newX0 = droppablePos0.x - myPos.x + 10;
      const newY0 = droppablePos0.y - myPos.y + 20;
      const newX1 = droppablePos1.x - myPos.x + 10;
      const newY1 = droppablePos1.y - myPos.y + 20;


      return [
        style,
        {
          ...style,
          transform: transform1 ? value === 10 ? `translate(${ newX0 }px, ${ newY0 }px)` : value === 7 ? `translate(${ newX1 }px, ${ newY1 - (wideScreen ? 0 : 15) }px)` : undefined : undefined,
          zIndex:    transform1 ? 1 : 0,
          opacity:   value === 10 && tensVal >= 2 ? 0 : 1
        },
        {
          ...style,
          transform: transform0 ? `translate(${ newX1 }px, ${ newY0 }px)` : undefined,
          zIndex:    transform0 ? 1 : 0,
        },
        {
          ...style,
          transform: transform2 ? `translate(${ newX0 }px, ${ newY0 }px)` : undefined,
          zIndex:    transform2 ? 1 : 0,
          opacity:   tensVal >= 2 ? 0 : 1
        },
        {
          ...style,
          transform: transform3 ? `translate(${ newX0 }px, ${ newY0 }px)` : undefined,
          zIndex:    transform3 ? 1 : 0,
          opacity:   tensVal >= 3 ? 0 : 1
        },
        {
          ...style,
          transform: transform4 ? `translate(${ newX0 }px, ${ newY0 }px)` : undefined,
          zIndex:    transform4 ? 1 : 0,
          opacity:   tensVal < 4 && pageNum < getPage('returnTen4') ? 1 : 0
        }
       ]
  },[value, pageNum, wideScreen, droppablePos0, droppablePos1, myPos, tensVal])

  return (
     <div 
       className = { classes.root }
       style     = { rootStyle }
     >
      <div 
          className    = { classes.root }
          style        = { draggableStyle }
          ref          = { boxRef } 
      />
      {
         value === 10 &&
         <>
            <div className = { classes.tenBox } style = { draggableStyle0 }/>
            <div className = { classes.tenBox } style = { draggableStyle2 }/>
            <div className = { classes.tenBox } style = { draggableStyle3 }/>
            <div className = { classes.tenBox } style = { draggableStyle4 }/>
         </>
      }
     </div>
  );
}



export default EggBox;








